import React from "react";
import { Header } from "../components/Header";
import { SectionFeatures } from "../components/SectionFeatures";
import { GlobalStyles } from "../components/ui/GlobalStyles";
import { SectionPrice } from "../components/SectionPrice";
import { SectionContact } from "../components/SectionContact";
import { SectionFooter } from "../components/SectionFooter";
import { Helmet } from "react-helmet";
import { ThemeProvider } from "styled-components";
import { theme } from "../lib/constant";
import imgScreensPers from "../../assets/screens/pers.jpg";
import imgScreensDons from "../../assets/screens/dons.jpg";
import imgScreensIncomplet from "../../assets/screens/incomplet.jpg";
import imgScreensSaisie from "../../assets/screens/saisie.jpg";
import { defineMessages, useIntl, FormattedMessage } from "react-intl";

const messages = defineMessages({
  headTitle: {
    id: "website.head.title",
    defaultMessage:
      "Flashix, fast & easy scanning solution right into your CRM",
  },
});

const Index = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Helmet>
        <html lang="fr" />
        <title>{formatMessage(messages.headTitle)}</title>
        <meta
          name="title"
          content="Flashix, fast & easy scanning solution right into your CRM"
        />
        <meta
          name="keywords"
          content="Flashix, fast & easy scanning solution for vouchers, loyalty cards, products & many more."
        />
        <meta
          name="description"
          content="With this easy app, you get real-time information from the field right into your Clixray CRM insuring a perfect track & trace of customer behaviors in any point of sale of your distribution network."
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=no"
        ></meta>
        <meta name="application-name" content="Flashix" />
        <meta name="author" content="Igloo" />
      </Helmet>

      <GlobalStyles />

      <ThemeProvider theme={theme}>
        <Header />
        <SectionFeatures
          items={[
            {
              label: (
                <FormattedMessage
                  id="sectionFeatures.item.redeem_voucher.label"
                  defaultMessage="Redeem voucher"
                />
              ),
              desc: (
                <FormattedMessage
                  id="sectionFeatures.item.redeem_voucher.desc"
                  defaultMessage="Mark a voucher as redeemed in one single scan and insure a perfect tracking of your promo campaigns."
                />
              ),
              imageUrl: imgScreensPers,
            },
            {
              label: (
                <FormattedMessage
                  id="sectionFeatures.item.activate_loyalty_card.label"
                  defaultMessage="Activate loyalty card"
                />
              ),
              desc: (
                <FormattedMessage
                  id="sectionFeatures.item.activate_loyalty_card.desc"
                  defaultMessage="Register new customer in one easy scan of their loyalty card."
                />
              ),
              imageUrl: imgScreensDons,
            },
            {
              label: (
                <FormattedMessage
                  id="sectionFeatures.item.register_purchase.label"
                  defaultMessage="Register purchase"
                />
              ),
              desc: (
                <FormattedMessage
                  id="sectionFeatures.item.register_purchase.desc"
                  defaultMessage="Scan loyalty cards & all product purchased to syncronize data into your CRM."
                />
              ),
              imageUrl: imgScreensIncomplet,
            },
            {
              label: (
                <FormattedMessage
                  id="sectionFeatures.item.track_given_goodies.label"
                  defaultMessage="Track given goodies"
                />
              ),
              desc: (
                <FormattedMessage
                  id="sectionFeatures.item.track_given_goodies.desc"
                  defaultMessage="Track & trace given promo goodies and activate instant partner rewards into your CRM."
                />
              ),
              imageUrl: imgScreensSaisie,
            },
          ]}
        />

        <SectionPrice />

        <SectionContact />

        <SectionFooter />
      </ThemeProvider>
    </>
  );
};

export default Index;
